import { createCommentVNode as _createCommentVNode, vShow as _vShow, vModelCheckbox as _vModelCheckbox, createElementVNode as _createElementVNode, withDirectives as _withDirectives, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fd596fea"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "checkbox-input-wrapper" }
const _hoisted_2 = ["disabled", "aria-describedby", "aria-label"]
const _hoisted_3 = { class: "checkbox-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createCommentVNode(" label 하나로 체크박스, 커스텀 UI, 텍스트(제목+설명)까지 모두 감싸기 "),
    _createElementVNode("label", _hoisted_1, [
      _createCommentVNode(" 실제 폼 컨트롤: checkbox "),
      _withDirectives(_createElementVNode("input", {
        class: "visually-hidden",
        type: "checkbox",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.checkedValue) = $event)),
        disabled: $props.disabled,
        onChange: $setup.onChangeChecked,
        "aria-describedby": $props.description ? $setup.descId : undefined,
        "aria-label": $props.title
      }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_2), [
        [_vShow, !$props.shouldHideCheckbox],
        [_vModelCheckbox, $setup.checkedValue]
      ]),
      _createCommentVNode(" 커스텀 체크마크 아이콘 "),
      _createElementVNode("span", {
        class: _normalizeClass(["checkmark", { disabled: $props.disabled, hide: $props.shouldHideCheckbox }]),
        "aria-hidden": "true"
      }, [
        ($setup.checkedValue)
          ? (_openBlock(), _createBlock($setup["InlineSvg"], {
              key: 0,
              class: _normalizeClass(["img-check", { disabled: $props.disabled }]),
              src: require('@/assets/icons/check.svg')
            }, null, 8 /* PROPS */, ["class", "src"]))
          : _createCommentVNode("v-if", true)
      ], 2 /* CLASS */),
      _createCommentVNode(" 시각 사용자용 텍스트(제목/설명) "),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", {
          class: _normalizeClass(["checkbox-title", { disabled: $props.disabled }])
        }, _toDisplayString($props.title), 3 /* TEXT, CLASS */),
        ($props.description)
          ? (_openBlock(), _createElementBlock("span", {
              key: 0,
              id: $setup.descId,
              class: "checkbox-description"
            }, _toDisplayString($props.description), 1 /* TEXT */))
          : _createCommentVNode("v-if", true)
      ])
    ])
  ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
}